import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { checkoutUrl } from '../data/copy';
interface CtaButtonProps {
  children: React.ReactNode;
  href?: string;
  size?: 'default' | 'large';
  variant?: 'green' | 'outline';
  className?: string;
}
const variants = {
  green: 'bg-green text-shell hover:bg-green-light shadow-[0_18px_36px_-20px_rgba(20,96,58,0.85)] focus-visible:outline-green',
  outline: 'border border-green/40 text-green-deep hover:border-green hover:bg-green-soft focus-visible:outline-green'
};
export function CtaButton({
  children,
  href = checkoutUrl,
  size = 'default',
  variant = 'green',
  className = ''
}: CtaButtonProps) {
  const sizing = size === 'large' ? 'px-8 py-5 text-[15px]' : 'px-7 py-4 text-[13px] sm:text-sm';
  return <a href={href} className={`group inline-flex items-center justify-center gap-3 rounded-full text-center font-sans font-bold uppercase tracking-[0.1em] transition-[background-color,border-color,color,transform,box-shadow] duration-150 ease-out hover:-translate-y-0.5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 active:translate-y-0 ${variants[variant]} ${sizing} ${className}`} data-id="element-75" data-mp="vdmsifez1g58">
      <span data-id="element-76" data-mp="3ey42m2pnd7np">{children}</span>
      <ArrowRightIcon className="h-4 w-4 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" strokeWidth={2.2} aria-hidden="true" data-id="element-77" data-mp="3ewsxnzkgttv0" />
    </a>;
}